import secondaryComponents from "../..";
import Images from "../../../../assets/images";
import { useStorefrontTable } from "./useStorefrontTable";
import styles from "./styles.module.scss";

export const StorefrontTable = ({
  storefrontList = [],
  metaDetails = {},
  gotoPage = () => {},
}) => {
  const {
    instance,
    isFoodMenuWidget,
    isDeleteFoodMenu,
    isDeletingStorefront,
    setIsDeleteFoodMenu,
    setIsFoodMenuWidget,
    handleDeleteStorfront,
  } = useStorefrontTable({
    storefrontList,
  });

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    instance;

  return (
    <>
      <secondaryComponents.TableHelper
        getTableProps={getTableProps}
        getTableBodyProps={getTableBodyProps}
        headerGroups={headerGroups}
        rows={rows}
        prepareRow={prepareRow}
        hasAction={true}
        classNames={styles.tableSection}
      >
        <div className="text-center mt-5">
          <img src={Images.foodMenuEmptyState} width="250px" alt="" />
          <h5>You have no Storefront</h5>
          <p>
            Use the “Create Storefront” button above to add your storefront.
            When you do, it will appear here.
          </p>
        </div>
      </secondaryComponents.TableHelper>

      {/* pagination */}
      {storefrontList?.length > 0 && (
        <div className="mt-auto">
          <secondaryComponents.Pagination
            totalPageNumber={metaDetails?.last_page}
            handlePageClick={(value) => gotoPage(value?.selected + 1)}
            currentPage={metaDetails?.current_page}
          />
        </div>
      )}

      <secondaryComponents.SideModal
        isActive={!!isFoodMenuWidget}
        closeModal={() => setIsFoodMenuWidget(null)}
        width={1000}
      >
        <secondaryComponents.FoodMenuWidget
          closeWidget={() => setIsFoodMenuWidget(null)}
          menuId={isFoodMenuWidget}
        />
      </secondaryComponents.SideModal>

      <secondaryComponents.ConfirmDialog
        title="Delete Storefront"
        isOpen={!!isDeleteFoodMenu}
        setIsOpen={setIsDeleteFoodMenu}
        isLoading={isDeletingStorefront}
        handler={() => handleDeleteStorfront()}
      >
        <p className="text-center">
          Are you sure you want to delete this storefront?
        </p>
        <p className="text-center">This action can not be undone</p>
      </secondaryComponents.ConfirmDialog>
    </>
  );
};
